import { useTextes } from "@common/config";
import React from 'react';

export const SentForm = () => {
  const t = useTextes('Inscription', 'DemandeEnvoyee');

  return (
    <div className={'flex flex-col gap-4'}>

      <div className={'border-1 border-solid border-[#18753C] flex '}>

        <div className={'bg-[#18753C] flex flex-col p-2'}>
          <span className={'text-white'}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z"
                fill="white" />
            </svg>
          </span>
        </div>

        <div className={'p-2'}>
          <span>{t['INSCR_RECAP_TEXT1']}</span>
        </div>
      </div>

      <span className={'text-sm text-[#666666]'}>Vous recevrez un courriel de confirmation de création de votre compte suite à la validation de France compétences.</span>
    </div>
  );
};